import { gql } from '../../../apollo/__generated__';

export const DELETE_PLACE = gql(`
  mutation DeletePlace($placeId: ID!) {
    deletePlace(placeId: $placeId) {
      id
    }
  }
`);
